import { Eye, EyeOff } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

const SignUpForm = ({
  register,
  errors,
  showPassword,
  showConfirmPassword,
  setShowPassword,
  setShowConfirmPassword,
  loading,
}) => {
  return (
    <div className="space-y-4 mt-4">
      <div>
        <div className="mt-1">
          <input
            {...register("name", {
              required: "Full name is required",
              minLength: {
                value: 2,
                message: "Name must be at least 2 characters",
              },
            })}
            type="text"
            className="input bg-white"
            placeholder="Enter your full name"
          />
          {errors.name && (
            <p className="mt-1 text-sm text-red-600">{errors.name.message}</p>
          )}
        </div>
      </div>
      <div>
        <div className="mt-1">
          <input
            {...register("email", {
              required: "Email is required",
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: "Invalid email address",
              },
            })}
            type="email"
            className="input bg-white"
            placeholder="Enter your email"
          />
          {errors.email && (
            <p className="mt-1 text-sm text-red-600">{errors.email.message}</p>
          )}
        </div>
      </div>

      <div>
        <div className="mt-1 relative">
          <input
            {...register("password", {
              required: "Password is required",
            })}
            type={showPassword ? "text" : "password"}
            className="input pr-10 bg-white"
            placeholder="Create a password"
          />
          <button
            type="button"
            className="absolute inset-y-0 right-0 pr-3 flex items-center"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? (
              <EyeOff className="h-5 w-5 text-gray-400" />
            ) : (
              <Eye className="h-5 w-5 text-gray-400" />
            )}
          </button>
          {errors.password && (
            <p className="mt-1 text-sm text-red-600">
              {errors.password.message}
            </p>
          )}
        </div>
      </div>

      <div>
        <div className="mt-1 relative">
          <input
            {...register("passwordConfirm", {
              required: "Please confirm your password",
              validate: (value, { password }) =>
                value === password || "Passwords do not match",
            })}
            type={showConfirmPassword ? "text" : "password"}
            className="input pr-10 bg-white"
            placeholder="Confirm your password"
          />
          <button
            type="button"
            className="absolute inset-y-0 right-0 pr-3 flex items-center"
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
          >
            {showConfirmPassword ? (
              <EyeOff className="h-5 w-5 text-gray-400" />
            ) : (
              <Eye className="h-5 w-5 text-gray-400" />
            )}
          </button>
          {errors.passwordConfirm && (
            <p className="mt-1 text-sm text-red-600">
              {errors.passwordConfirm.message}
            </p>
          )}
        </div>
      </div>
      
      {/* <div className="flex items-center">
        <input
          id="agree-terms"
          name="agree-terms"
          type="checkbox"
          required
          className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
        />
        <label
          htmlFor="agree-terms"
          className="ml-2 block text-sm text-gray-900"
        >
          I agree to the{" "}
          <Link to="/terms" className="text-primary-600 hover:text-primary-500">
            Terms of Service{" "}
          </Link>{" "}
          and{" "}
          <Link
            to="/privacy"
            className="text-primary-600 hover:text-primary-500"
          >
            Privacy Policy{" "}
          </Link>
        </label>
      </div> */}
    </div>
  );
};

export default SignUpForm;
